<h1 mat-dialog-title> Rechaza Convenio </h1> <br/>

<mat-dialog-content>

    <p>
        <mat-form-field appearance="outline" class="mat-input">

            <mat-label> Tipo Rechazo </mat-label>

            <mat-select [(ngModel)]="data.tipoRechazo" required>

                <mat-option *ngFor="let tipoRechazo of data.tiposRechazo" value="{{tipoRechazo.id + '-' + tipoRechazo.descripcion}}">

                    {{tipoRechazo.descripcion}}

                </mat-option>

            </mat-select>

        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance="outline" class="mat-input">

            <mat-label> Comentario Rechazo </mat-label>

            <input matInput placeholder="Comentario Rechazo" [(ngModel)]="data.comentarioRechazo" required>

        </mat-form-field>
    </p>

</mat-dialog-content>

<div mat-dialog-actions>

    <button mat-button class="mat-raised-button btn-danger" (click)="onRechazarClick()"> 
        <i class = "fa fa-times"> </i> Rechazar
    </button>

    <button mat-button class="mat-raised-button btn-dark mat-button" (click)="onCancelarClick()"> 
        <i class = "fa fa-trash"> </i> Cancelar
    </button>

</div>